'use client';

import { ReactNode } from 'react';
import { useAtom } from 'jotai';
import type { User } from '@/lib/auth';
import AppNavbar from '../AppNavbar/AppNavbar';
import AppSidebar from '../AppSidebar/AppSidebar';
import { SidebarInset, SidebarProvider } from '../UIComponents/Sidebar';
import { TokenLimitDialog } from '../TokenLimitDialog';
import { tokenLimitDialogAtom } from '@/_state/atoms/tokenLimitAtom';

function AppLayout({ children, user }: { children: ReactNode; user: User | null }) {
	const [tokenLimitDialog, setTokenLimitDialog] = useAtom(tokenLimitDialogAtom);

	return (
		<SidebarProvider className='h-svh overflow-hidden'>
			<AppSidebar />
			<SidebarInset className='overflow-hidden'>
				{/* Subtle gradient blobs for visual warmth (light mode only) */}
				<div className='pointer-events-none fixed inset-0 z-0 dark:hidden'>
					<div className='absolute top-1/4 -left-32 h-[500px] w-[500px] rounded-full bg-pink-500/[0.07] blur-[120px]' />
					<div className='absolute right-0 bottom-1/3 h-[400px] w-[400px] rounded-full bg-purple-500/[0.05] blur-[100px]' />
				</div>
				<AppNavbar user={user} />
				<main className='flex h-full w-full flex-1 flex-col gap-4 overflow-hidden p-0 pt-0 pb-0 md:p-4 md:pt-0 md:pb-0'>
					{children}
				</main>
			</SidebarInset>
			<TokenLimitDialog
				isOpen={tokenLimitDialog.isOpen}
				resetAt={tokenLimitDialog.resetAt}
				onClose={() => setTokenLimitDialog({ isOpen: false, resetAt: null })}
			/>
		</SidebarProvider>
	);
}

export default AppLayout;
